import { useEffect } from "react";

import { $isLinkNode } from "@lexical/link";
import { useLexicalComposerContext } from "@lexical/react/LexicalComposerContext";
import { $findMatchingParent } from "@lexical/utils";
import { $getNearestNodeFromDOMNode } from "lexical";

import type { RTEComponentDefs } from "../RichTextEditorProps";

export interface LinkClickPluginDefs {
  readonly onLinkClick: (url: string) => void;
}

export const LinkClickPlugin: RTEComponentDefs<LinkClickPluginDefs> = ({ onLinkClick }) => {
  const [editor] = useLexicalComposerContext();

  useEffect(() => {
    const handleClick = (event: MouseEvent) => {
      const { target } = event;
      if (!(target instanceof Node)) return;
      const linkUrl = editor.read(() => {
        const node = $getNearestNodeFromDOMNode(target);
        if (node == null) return null;
        const linkNode = $findMatchingParent(node, $isLinkNode);
        return $isLinkNode(linkNode) ? linkNode.getURL() : null;
      });
      if (linkUrl != null) onLinkClick(linkUrl);
    };
    return editor.registerRootListener((rootElement) => {
      if (rootElement === null) return;
      rootElement.addEventListener("click", handleClick);
      return () => rootElement.removeEventListener("click", handleClick);
    });
  }, [editor, onLinkClick]);

  return null;
};
